import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosAplicacionesService,
  CultivoItem,
} from "../../../../generated/grpc/catalogos_aplicaciones_pb";

/** Variante gRPC-Web (con delta) de `CultivoGetCatalogService` (ver ese archivo). */
export class CultivoGrpcCatalogService extends BaseGrpcCatalogService<CultivoItem> {
  protected readonly storeName = "cultivos" as const;
  protected readonly sortFieldName = "nombre";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<CultivoItem>> {
    const client = createClient(CatalogosAplicacionesService, grpcTransportProvider.get());

    try {
      const response = await client.listCultivos({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de cultivos. */
export const cultivoGrpcCatalogService = new CultivoGrpcCatalogService();
